import MetaContent from '../components/MetaContent'
import { attributes } from '../content/join-the-team.md'
import TextHero from '../components/careers/TextHero'
import Perks from '../components/careers/Perks'
import Employees from '../components/careers/Employees'
import About from '../components/careers/About'
import Video from '../components/careers/Video'
import { useState } from 'react'
import SplitCallout from '../components/careers/SplitCallout'
import Markdown from 'react-markdown'
import SlantedBackground from '@/components/SlantedBackground'

export default function JoinTheTeam() {
  const [videoIsVisible, setVideoIsVisible] = useState(false)
  const {
    bgVideo,
    metaTitle,
    metaDescription,
    heroTitle,
    heroText,
    perksTitle,
    perksSubTitle,
    perksText,
    perksImageSrc,
    perksList,
    employeesButtonText,
    employeesEmbedVideo,
    employeeOwnedList,
    employeesList,
    employeeOwned,
    aboutTitle,
    aboutImage,
    aboutList,
    comparisons,
    videoTitle,
    videoEmbedUrl,
    videoPlaceholderImage,
    videoPlaceholderImageAlt,
  } = attributes

  return (
    <>
      <MetaContent title={metaTitle} description={metaDescription} />

      <main>
        <TextHero title={heroTitle} text={heroText} />
        <Video
          bgVideo={bgVideo}
          youtubeEmbedUrl={videoEmbedUrl}
          showVideoModal={videoIsVisible}
          setVideoIsVisible={setVideoIsVisible}
          placeHolderImage={videoPlaceholderImage}
          videoPlaceholderImageAlt={videoPlaceholderImageAlt}
        />
        <Perks
          title={perksTitle}
          subTitle={perksSubTitle}
          text={perksText}
          image={perksImageSrc}
          list={perksList}
        />
        <SlantedBackground smallPadding backgroundColor="[#F0F4F2]">
          <div className="flex flex-col px-4 md:px-0 items-center justify-center pt-[1.375rem] md:pt-[61px] xl:pt-[6rem] lg:gap-y-[.50rem] text-green-100 -mb-[52px] xl:max-w-[78vw] lg:mb-0 ">
            <span className="mx-auto text-[1.25rem] leading-6 text-center lg:text-2xl font-ttHovesMedium mb-[48px] w-[70%] md:w-full lg:tracking-[.0025em]">
              Respect for our people can&apos;t be matched
            </span>
            <span className="text-[2.125rem] leading-[41px] lg:text-[4.5rem] lg:leading-[120%] mt-0 font-ttHovesBold text-center mx-auto -tracking-[0.005em]">
              Employee owned with our ESOP
            </span>
          </div>

          <SplitCallout
            largerImage
            image={employeeOwnedList[0].imageSrc}
            imageAlt={perksTitle}
            additionalClasses=" mb-[89px] lg:mb-[200px]"
          >
            <div className="flex flex-col gap-y-[3rem] md:gap-y-6 lg:gap-y-[100px] xl:mt-[82px]">
              {employeeOwned?.map((item: any, index: number) => {
                return (
                  <span className="" key={'employeeOwned-' + index}>
                    <Markdown className="__employeeOwnedTitle">
                      {item.title}
                    </Markdown>
                    <div
                      className="__employeeOwnedSubtitle"
                      dangerouslySetInnerHTML={{ __html: item.subtitle }}
                    />
                  </span>
                )
              })}
            </div>
            <div className="pb-14 lg:p-0" />
          </SplitCallout>

          <SplitCallout
            additionalClasses=" lg:mb-[218px]"
            largerImage
            smallPadding
            image={employeeOwnedList[1].imageSrc}
            imageAlt={perksTitle}
            reverse
          >
            <div className="ESOP -mb-5">
              <div className="flex flex-col pb-[32px] px-[23px] pt-[48px] lg:py-0 gap-y-[2.9rem] xl:px-0 lg:gap-y-6 xl:gap-y-[90px] xl:mt-[125px]">
                {comparisons?.map((item: any, index: number) => {
                  return (
                    <span
                      className="xl:ml-9 xl:mr-12"
                      key={'comparison-' + index}
                    >
                      <Markdown className="__comparisonEyebrow">
                        {item.eyebrow}
                      </Markdown>
                      <div
                        className="my-3 __comparisonTitle"
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      />
                      <div className=" -mb-4">
                        {item?.data?.map((dataItem: any, dataIndex: number) => {
                          return (
                            <div
                              key={'comparisonItem-' + dataIndex}
                              className="flex items-center ml-1 lg:ml-0 mb-2 gap-x-[7px]"
                            >
                              <div className="flex items-center">
                                {dataItem?.icons?.map(
                                  (icon: any, dataItemIndex: number) => {
                                    return (
                                      <img
                                        key={'comparisonIcon-' + dataItemIndex}
                                        className={
                                          icon.src.includes('Half')
                                            ? 'h-10 w-6'
                                            : 'w-10 h-10'
                                        }
                                        src={icon.src}
                                        alt="Icon"
                                      />
                                    )
                                  }
                                )}
                              </div>
                              <Markdown className="__comparisonCopy">
                                {dataItem.copy}
                              </Markdown>
                            </div>
                          )
                        })}
                      </div>
                    </span>
                  )
                })}
              </div>
            </div>
            <div className="pb-5 lg:pb-0" />
          </SplitCallout>
        </SlantedBackground>
        <div className="hidden lg:block">
          <Employees
            youtubeEmbedUrl={employeesEmbedVideo}
            buttonText={employeesButtonText}
            list={employeesList}
          />
        </div>

        <div className="grid lg:hidden grid-row-3 mx-auto items-center mt-[104px] lg:mt-0 gap-y-[.7rem] md:gap-y-8">
          {employeesList.map((item: any, i: number) => (
            <SplitCallout
              smallPadding
              key={`EmployeesList_${i}`}
              image={employeesList[i].imageSrc}
              imageAlt={perksTitle}
            >
              <div className=" grid gap-[8px] text-npt-classic px-6 py-[23px] w-full">
                <span className="text-[1.25rem] leading-[120%] lg:text-2xl font-ttHovesMedium">
                  {item.title}
                </span>
                <span className=" font-ttHovesMedium text-nptBase leading-[120%]">
                  {item.subTitle}
                </span>
                <p className="font-ttHovesMedium text-nptBase leading-[120%]">
                  {item.text}
                </p>
              </div>
            </SplitCallout>
          ))}
        </div>

        <About title={aboutTitle} imageSrc={aboutImage} list={aboutList} />
      </main>
    </>
  )
}
